import { call, put, takeLatest } from "redux-saga/effects";
import { dashBoardActions } from "./dashBoardSlice";
import { ApiResponse } from "models";
import {
  CustomerPayload,
  CustomerSubmitForm,
  IdentityPayload,
} from "models/customer";
import dashBoardApi from "api/dashBoard";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* getBrandChartDataRequest(action: PayloadAction<CustomerPayload>) {
  try {
    const response: ApiResponse = yield call(
      dashBoardApi.getBrandChartData,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(dashBoardActions.getBrandChartDataSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(dashBoardActions.getBrandChartDataFailed(errorData));
  }
}
function* getSalesChartDataRequest(action: PayloadAction<CustomerPayload>) {
  try {
    const response: ApiResponse = yield call(
      dashBoardApi.getSalesChartData,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(dashBoardActions.getSalesChartDataSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(dashBoardActions.getSalesChartDataFailed(errorData));
  }
}
function* getOrderChartDataRequest(action: PayloadAction<CustomerPayload>) {
  try {
    const response: ApiResponse = yield call(
      dashBoardApi.getOrderChartData,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(dashBoardActions.getOrderChartDataSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(dashBoardActions.getOrderChartDataFailed(errorData));
  }
}

export default function* dashBoardSaga() {
  yield takeLatest(
    dashBoardActions.getBrandChartDataRequest.type,
    getBrandChartDataRequest
  );
  yield takeLatest(
    dashBoardActions.getSalesChartDataRequest.type,
    getSalesChartDataRequest
  );
  yield takeLatest(
    dashBoardActions.getOrderChartDataRequest.type,
    getOrderChartDataRequest
  );
}
